export const initialCustomerData = {
    firstName: '',
    lastName:'',
    email: '',
    phone: '',
    streetAddress: '',
    city:'',
    state:'',
    zipCode:'',
    bio: ''
};
